import styled from "styled-components";

import { Box, FlexDiv } from "@/components/Atoms/Box";
import Typography from "@/foundation/Typography/V2";

export const PageWrapper = styled(FlexDiv)`
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 600px;
`;

export const Header = styled(FlexDiv)`
  display: flex;
  padding: 20px 16px 24px 16px;
  flex-direction: column;
  align-items: flex-start;
  gap: 4px;
  margin-bottom: 24px;
  margin-top: 8px;
`;

export const QuestionSection = styled(FlexDiv)`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;

  gap: 16px;
  width: 100%;
`;

export const SectionTitle = styled(Typography)`
  color: #6e55d3;
  font-family: var(--man);
  font-size: 20px;
  font-style: normal;
  font-weight: 700;
  line-height: 24px;
`;

export const SectionItem = styled(FlexDiv)`
  display: flex;
  padding: 0px 16px;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;
`;

export const QuestionItem = styled(FlexDiv)`
  display: flex;
  padding: 8px 8px 0px 8px;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;
  align-self: stretch;
  //   background: var(--gray-25, #fcfcfd);
`;

export const QuestionList = styled(Box)`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-gap: 24px;
  @media only screen and (max-width: 1200px) {
    grid-template-columns: repeat(1, 1fr);
  }
`;
export const AccordionWrapper = styled(FlexDiv)`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  width: 100%;
  //   align-items: center;
`;

export const AnswerWrapper = styled(FlexDiv)`
  display: flex;
  width: 100%;
  flex-direction: column;
  gap: 16px;
`;
export const AnswerText = styled(Typography)`
  color: #344054;
  font-family: var(--man);
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: 20px;
  letter-spacing: 0.4px;
  // text-align: justify;

  span {
    color: #2f2c2c;
    font-weight: bold;
  }
`;

export const LI = styled.li`
  padding-left: 10px;
  position: relative;
  line-height: 1.4;
  list-style-type: none;
  &::before {
    content: "•";
    position: absolute;
    left: 0;
  }
`;
export const PageTitle = styled(Typography)`
  color: #363f72;
  font-family: var(--man);
  font-size: 24px;
  font-style: normal;
  font-weight: 700;
  line-height: 24px;
`;
export const SubTitle = styled(Typography)`
  color: #667085;
  font-family: var(--man);
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  letter-spacing: 0.4px;
`;

export const IntercomWrapper = styled(FlexDiv)`
  display: flex;
  width: 100%;
  padding: 16px;
  align-items: center;
  gap: 16px;
  border-radius: 16px;

  border: 1px solid #fedf89;
  background: #fffaeb;
  box-shadow: 0px 4px 8px 0px rgba(252, 209, 80, 0.1);
  transition: box-shadow 0.3s ease;

  &:active {
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
    opacity: 0.8;
  }
`;

export const IntercomTextWrapper = styled(FlexDiv)`
  display: flex;
  width: 100%;
  flex-direction: column;
  gap: 4px;
`;

export const IntercomTitle = styled(Typography)`
  color: #3e1c96;
  font-family: var(--man);
  font-size: 14px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  align-self: stretch;
`;

export const IntercomSubTitle = styled(Typography)`
  align-self: stretch;
  color: #293056;
  font-family: var(--man);
  font-size: 12px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
`;
